import React from 'react';
import { Package as PackageIcon } from 'lucide-react';

// Placeholder used when `image_url` is null (Phase 11 seeds have no images).
// Kept elegant: subtle indigo gradient wash + outline mark. Zero broken image
// requests, zero "🖼" emojis.
export default function ProductImage({ src, alt = '', className = '', rounded = 'rounded-xl' }) {
    const [broken, setBroken] = React.useState(false);
    const showImg = !!src && !broken;

    if (showImg) {
        return (
            <img
                src={src}
                alt={alt}
                onError={() => setBroken(true)}
                className={`w-full h-full object-cover ${rounded} ${className}`}
                draggable={false}
            />
        );
    }

    return (
        <div
            data-testid="product-image-placeholder"
            role="img"
            aria-label={alt || 'Image du produit indisponible'}
            className={`w-full h-full ${rounded} flex items-center justify-center relative overflow-hidden ${className}`}
            style={{
                background:
                    'radial-gradient(ellipse 80% 90% at 20% 20%, rgba(155,127,244,0.28) 0%, rgba(155,127,244,0) 55%), ' +
                    'radial-gradient(ellipse 60% 70% at 90% 80%, rgba(75,63,216,0.28) 0%, rgba(75,63,216,0) 55%), ' +
                    'linear-gradient(140deg, #F5F6FA 0%, #EDEBFA 60%, #E0DAFF 100%)',
            }}
        >
            <PackageIcon size={38} strokeWidth={1.4} className="text-[#4B3FD8]/70" />
        </div>
    );
}
